import React from 'react';
import Routes from './Routes';
import { GlobalStyles } from './Styles/globalStyles';

const App = () => (
  <>
    <Routes />
    <GlobalStyles />
  </>
);

export default App;
